import { ArrowUpRightFromSquareIcon } from "@octopusdeploy/design-system-icons";
import * as React from "react";
import { useDispatchLinkAnalytics } from "../../routing/OctopusRoutingContext";
import type { LinkProps } from "./Link";
import { Link } from "./Link";
import { formatExternalUrl } from "./formatExternalUrl";
export type ExternalLinkProps = Pick<LinkProps, "href" | "children" | "size" | "weight" | "onClick"> & {
    trackAnalytics?: boolean;
};
export function ExternalLink({ href, children, size, weight, onClick, trackAnalytics = true }: ExternalLinkProps) {
    const dispatchAnalytics = useDispatchLinkAnalytics();
    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
        if (trackAnalytics === true) {
            dispatchAnalytics(children, href, "Navigate to External Link");
        }
    };
    return (<Link href={formatExternalUrl(href)} trailingIcon={<ArrowUpRightFromSquareIcon size={"font-size"}/>} openInNewTab size={size} weight={weight} onClick={handleOnClick}>
            {children}
        </Link>);
}
